import React from 'react';

import { copyToClipboard } from '@eika-infrastruktur/utils';
import { DetailsListItem } from '@eika/details-list';
import { IconTypes } from '@eika/icon';

import { useValidateIban } from '../../fetchHooks/useCrossBorderBankValidation';
import type { Account } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';

interface Props {
    account: Account;
}

const AccountCrossborderInfo: React.FC<Props> = ({ account }) => {
    const translated = useTranslation();
    const { data: bankValidation } = useValidateIban(account?.iban, !account?.bank.bicCode);
    const bic = account.bank.bicCode ?? bankValidation?.bank?.bic;
    return (
        <>
            <DetailsListItem
                label={translated.accountDetails.iban}
                value={account.iban?.value}
                button={
                    account.iban
                        ? {
                              onClick: () => copyToClipboard(account?.iban?.value),
                              title: translated.accountDetails.copyIBAN,
                          }
                        : undefined
                }
                icon={IconTypes.COPY_24}
            />
            {bankValidation?.routingBicBank?.bic?.value ? (
                <>
                    {bic?.value && <DetailsListItem label={translated.accountDetails.sepaBic} value={bic.value} />}
                    <DetailsListItem
                        label={translated.accountDetails.routingBic}
                        value={bankValidation.routingBicBank.bic.value}
                    />
                </>
            ) : (
                <>{bic?.value && <DetailsListItem label={translated.accountDetails.bic} value={bic.value} />}</>
            )}
        </>
    );
};
export default AccountCrossborderInfo;
